import { useState } from 'react';
import toast from 'react-hot-toast';
import OrderController from '@/services/OrderController';
import { isNumericFee } from '@/utils/validation';

export const useOrderCompletion = ({ user, activeOrders }) => {
	const [completeOrderId, setCompleteOrderId] = useState(null);
	const [isCompleteOrderModalOpen, setIsCompleteOrderModalOpen] = useState(false);

	const [feeList, setFeeList] = useState(null);
	const [selectedFeeIdx, setSelectedFeeIdx] = useState(null);
	const [customFee, setCustomFee] = useState('');
	const [customFeeSelected, setCustomFeeSelected] = useState(false);

	const openCompleteModal = orderId => {
		setCompleteOrderId(orderId);
		setIsCompleteOrderModalOpen(true);

		if (!user?.cityLocation?.withFees) {
			return;
		}

		const order = activeOrders.find(o => o.id === orderId);
		setFeeList(order.shop?.feeList || null);
	};

	const onCloseCompleteModal = () => setIsCompleteOrderModalOpen(false);

	const onCloseCancelModal = () => {
		setFeeList(null);
		setSelectedFeeIdx(null);
		setCustomFeeSelected(false);
		onCloseCompleteModal();

		setCustomFee('');
	};

	const changeSelectedFeeIdx = idx => {
		setSelectedFeeIdx(idx);
		setCustomFeeSelected(false);
	};

	const changeCustomFee = fee => {
		setSelectedFeeIdx(null);
		setCustomFee(fee);
		setCustomFeeSelected(true);
	};

	const completeOrder = async () => {
		try {
			let fee;
			if (feeList) {
				if (!customFeeSelected && !(selectedFeeIdx >= 0)) {
					toast.error('Πρέπει να διαλέξεις μια προμήθεια');
					return;
				}

				if (customFee?.length > 0) {
					if (!isNumericFee(customFee)) {
						toast.error('Η προμήθεια πρέπει να είναι νούμερο');
						return;
					}
				}

				fee = selectedFeeIdx !== null ? feeList[selectedFeeIdx] : customFee;
			}

			const res = await OrderController.completeOrder(completeOrderId, parseFloat(fee));
			if (!res?.error) {
				toast.success('Η παραγγελία ολοκληρώθηκε');
				setFeeList(null);
				setSelectedFeeIdx(null);
				setCustomFeeSelected(false);
				onCloseCompleteModal();

				setCustomFee('');
			} else {
				console.log('errorr complete order', res?.code);
				toast.error(
					`Κάποιο πρόβλημα προέκυψε${typeof res.error === 'string' || res?.code ? ':' : ''}${
						typeof res.error === 'string' ? ` ${res.error}` : ''
					}${res?.code ? ` (${res.code})` : ''}`,
				);
			}
		} catch (error) {
			console.log('complete error: ', error);
			toast.error(`Κάποιο πρόβλημα προέκυψε`);
		}
	};

	return {
		completeOrderId,
		isCompleteOrderModalOpen,
		feeList,
		selectedFeeIdx,
		customFee,
		customFeeSelected,
		openCompleteModal,
		onCloseCompleteModal,
		onCloseCancelModal,
		changeSelectedFeeIdx,
		changeCustomFee,
		completeOrder,
	};
};
